import { useState } from 'react';

export default function TechService(props) {

  const nextService = () => {
    props.clearService();
  }

  const finishService = () => {
    let date = new Date();
    let input=document.getElementById('comment');
    props.service.extraData = input.value;
    props.service.execution_tstamp = date.toISOString();
    props.service.cancel_tstamp = null;
    props.setServiceQueue(props.service);
    nextService();
  }

  const cancelService = () => {
    let date = new Date();
    let input=document.getElementById('comment');
    props.service.extraData = input.value;
    props.service.execution_tstamp = null;
    props.service.cancel_tstamp = date.toISOString();
    props.setServiceQueue(props.service);
    nextService();
  }

  let content;
  content = <div>
    <h3 className="ui inverted block header"><i className="chevron left icon" onClick={props.clearService}></i> Automat "{props.service.machine.serial_number}"</h3>
    <div>
      <strong>Standort</strong><br />
      <a target='_blank' href={"https://maps.apple.com/?daddr="+props.service.site.address+","+props.service.site.zip+"%20"+props.service.site.city+"&dirflg=d"}>{props.service.site.name} {props.service.site.description}<br />
      {props.service.site.address}<br />
      {props.service.site.zip} {props.service.site.city}</a><br />
      <br />
      <strong>Beschreibung</strong><br />
      {props.service.service.description}<br />
      <br />
      <strong>Priorität</strong><br />
      {props.service.service.priority}
      <div className='ui divider'></div>
      <strong>Kommentar</strong>
      <div className="ui fluid input">
        <textarea name="comment" id="comment" className="ui fluid" style={{width:'100%'}} rows={10}>

        </textarea>
      </div>
      <div className='ui divider'></div>
      <div className="ui two spaced buttons">
        <button className='ui negative labeled icon button' onClick={cancelService}><i className="times icon"></i> Storno</button>
        <button className='ui positive labeled icon button' onClick={finishService}><i className='check icon'></i> OK</button>
      </div>
    </div>
  </div>


  return (
    <div>

      {content}
    </div>
  );
}